import React from "react";
import { Dropdown, IDropdownOption, ResponsiveMode } from "@fluentui/react";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { Dimension } from "../../../api/models/dimension";

export const DimensionSelect = ({
  availableDimensions,
  onChange,
  selectedKey,
  disabled,
}: {
  availableDimensions: Dimension[];
  onChange: (i: Dimension) => void;
  selectedKey: string | undefined;
  disabled: boolean;
}) => {
  function onChooseDimension(option: IDropdownOption) {
    onChange(availableDimensions.find((d) => d.oid === option.key));
  }

  return (
    <Dropdown
      id="dimension_dropdown"
      placeholder={formatMessage("cof.objectsource.placeholder.dimension")}
      label={formatMessage("cof.objectsource.dimension")}
      options={availableDimensions?.map((d) => ({ key: d.oid, text: d.desc }))}
      onChange={(_event, option) => onChooseDimension(option)}
      selectedKey={selectedKey ?? null}
      responsiveMode={ResponsiveMode.small}
      disabled={disabled}
      required
    />
  );
};
